import { ErrorBoundary } from 'app/components/ErrorBoundary';
import { lazy } from 'react';

const ErrorBoundaryUI = lazy(() => import('app/components/ErrorBoundaryUI'));

const WithErrorBoundary = WrappedComponent => {
  const ComponentWithErrorBoundary = ({ ...props }) => {
    return (
      <ErrorBoundary fallbackUI={<ErrorBoundaryUI />}>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  };

  ComponentWithErrorBoundary.displayName = `WithErrorBoundary(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return ComponentWithErrorBoundary;
};

export default WithErrorBoundary;
